import { Command, UserProfile } from '@nextforce/api'
import { makeStyles } from '@rneui/themed'
import React from 'react'
import { ScrollView } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { CommandButtons } from 'shared/components/command_buttons'
import { UserDetails } from 'shared/components/user/user_details'

interface Props {
  profile: UserProfile | undefined
  onCommandButtonPress(command: Command): Promise<void>
}

export function UserProfileView({ profile, onCommandButtonPress }: Props) {
  const styles = useStyles()

  if (!profile) {
    return null
  }

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.root}>
      <ScrollView contentContainerStyle={styles.container}>
        <UserDetails user={profile} />
        <CommandButtons
          commands={profile.commands}
          onButtonPress={onCommandButtonPress}
        />
      </ScrollView>
    </SafeAreaView>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
  },
  container: {
    flexGrow: 1,
    justifyContent: 'space-between',
    backgroundColor: theme.colors?.grey5,
    paddingVertical: 20,
  },
}))
